module.exports = __webpack_public_path__ + "img/light.79ca8719.jpg";